import { getSignIn } from "../../../helpers/realbackend_helper";
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    const response = await getSignIn({
      username: user.username,
      password: user.password,
    });

    if (!response || !response.accessToken) {
      dispatch(apiError("Нэвтрэхэд алдаа гарлаа"));
      return;
    }

    const {
      accessToken,
      company,
      department,
      section,
      username,
      first_name,
      image_url,
      last_name,
      phone,
      role,
      _id,
      type,
      isLeader,
    } = response;

    const authUser = {
      accessToken,
      company,
      department,
      section,
      username,
      first_name,
      image_url,
      last_name,
      phone,
      role,
      _id,
      type,
      isLeader,
    };

    localStorage.setItem("authUser", JSON.stringify(authUser));

    dispatch(loginSuccess(response));

    if (
      role === "Админ" ||
      company === "Ти Ай Ложистик ХХК" ||
      company === "TILogistic"
    ) {
      if (
        role === "Терминалын хэлтсийн дарга" ||
        role === "Авто ачигчийн жолооч"
      ) {
        history("/vehicles");
      } else if (department === "Терминалын газар") {
        if (
          role === "Терминалын газрын захирал" ||
          role === "Кассир" ||
          role === "Терминалын хэлтсийн дарга"
        ) {
          history("/fees");
        } else if (role === "Агуулахын эрхлэгч /ГБА/") {
          history("/warehousereport");
        } else {
          history("/containers");
        }
      } else if (department === "Захиргаа удирдлага, санхүүгийн газар") {
        if (role !== "Архив, бичиг хэргийн ажилтан") {
          history("/employees");
        } else {
          history("/documents");
        }
      } else if (section === "Санхүүгийн хэлтэс") {
        history("/balance");
      } else if (department === "Тээврийн газар") {
        history("/orders");
      } else {
        history("/user-settings");
      }
    } else {
      if (type === "Терминалын газрын хэрэглэгч") {
        history("/client-containers");
      } else if (type === "Тээврийн газрын хэрэглэгч") {
        history("/tracking");
      } else {
        history("/user-settings");
      }
    }
  } catch (error) {
    dispatch(apiError(error) || error?.message);
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error?.message));
  }
};

export const resetLoginFlag = () => (dispatch) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error?.message));
  }
};
